'use strict';

/**
 * Render function.
 *
 * @this Object
 *
 * @param {Node} $node DOM element of list item
 */
function render ( $node ) {
    // <div class="content-item-app">
    //     <div class="content-item-app-container" style="background-color: #00d1eb;">
    //         <div class="content-item-app-overlay"></div>
    //         <div class="content-item-app-icon" style="background-image: url('app/img/720/icons/tv.png'); "></div>
    //         <div class="content-item-app-name">TV</div>
    //     </div>
    // </div>
    $node.className = 'content-item-app';

    $node.$container = $node.appendChild(document.createElement('div'));
    $node.$container.className = 'content-item-app-container';
    $node.$container.style.backgroundColor = this.data.colors.splashBackground;

    $node.$overlay = $node.$container.appendChild(document.createElement('div'));
    $node.$overlay.className = 'content-item-app-overlay';

    $node.$icon = $node.$container.appendChild(document.createElement('div'));
    $node.$icon.className = 'content-item-app-icon';
    $node.$icon.style.backgroundImage = 'url("' + this.data.icons.primeLogoNormal + '")';

    $node.$name = $node.$container.appendChild(document.createElement('div'));
    $node.$name.className = 'content-item-app-name';
    $node.$name.innerText = this.data.name;
}

module.exports = {
    render: render,
    focus: function ( $node ) {
        $node.$container.className = 'content-item-app-container--focus';
        $node.$overlay.className = 'content-item-app-overlay--focus';
        $node.$icon.className = 'content-item-app-icon--focus';
        $node.$name.className = 'content-item-app-name--focus';
        $node.$icon.style.backgroundImage = 'url("' + this.data.icons.primeLogoActive + '")';
    },
    blur: function ( $node ) {
        $node.$container.className = 'content-item-app-container';
        $node.$overlay.className = 'content-item-app-overlay';
        $node.$icon.className = 'content-item-app-icon';
        $node.$name.className = 'content-item-app-name';
        $node.$icon.style.backgroundImage = 'url("' + this.data.icons.primeLogoNormal + '")';
    }
};
